module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ua":{"title":"Збільшення продажів","btn_save":"Зберегти","btn_close":"Закрити"}}')
  delete Component.options._Ctor
}
